export default "__VITE_ASSET__CABwgCkf__"